const RenderOnAuthenticated = ({ userService,children }) => (userService.isLoggedIn()) ? children : <></>;

export default RenderOnAuthenticated